import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b229560"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "cancellation-text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Summary:")
], -1))
const _hoisted_4 = { class: "account-summary-section" }
const _hoisted_5 = { class: "policy-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Insured Contact:", -1))
const _hoisted_7 = { class: "policy-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Producer Code(s):", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Active UW alerts:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Issue", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Third-party decline reasons:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason", -1))
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Request review pending:", -1))
const _hoisted_19 = { style: {"padding-left":"15px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Help center request", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Policies:")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Business Owners' Policy (BOP)", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Attune WC", -1))
const _hoisted_26 = { key: 4 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Quotes:")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Business Owners' Policy (BOP)", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "⚠Rollover quotes:", -1))
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "⚠Renewal quotes:", -1))
const _hoisted_33 = { key: 2 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Quotes:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Attune WC", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Quotes:", -1))
const _hoisted_38 = { key: 5 }
const _hoisted_39 = {
  key: 6,
  class: "quote-section"
}
const _hoisted_40 = {
  key: 7,
  class: "quote-section"
}
const _hoisted_41 = {
  key: 8,
  class: "quote-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_PolicyDetails = _resolveComponent("PolicyDetails")!
  const _component_QuoteDetails = _resolveComponent("QuoteDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Some policy information failed to load."))
      : _createCommentVNode("", true),
    (_ctx.cancellationTermPeriod !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.cancellationText), 1))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.accountContact), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.producerCodeList), 1)
      ])
    ]),
    (_ctx.hasOutstandingUwAlerts || _ctx.hasThirdPartyDecline || _ctx.hasHelpCenterRequestIssue)
      ? (_openBlock(), _createBlock(_component_CollapsibleSection, {
          key: 2,
          collapsed: _ctx.isIssuesCollapsed,
          onToggleCollapse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleIssuesCollapsed())),
          class: "alert-pane"
        }, {
          caption: _withCtx(() => [
            _createElementVNode("span", { innerHTML: _ctx.issuesHeader }, null, 8, _hoisted_9)
          ]),
          content: _withCtx(() => [
            (_ctx.hasOutstandingUwAlerts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outstandingUwAlerts, (alert) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: alert.alertName,
                      class: "alert-pane"
                    }, [
                      _createElementVNode("div", null, [
                        _hoisted_12,
                        _createTextVNode(": " + _toDisplayString(alert.modelOutput.reason), 1)
                      ]),
                      (!alert.modelOutput.isBrokerVisible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "(This alert is not visible to the broker.)"))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasThirdPartyDecline)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartDeclineReasons, (reason) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: reason,
                      class: "alert-pane"
                    }, [
                      _createElementVNode("div", null, [
                        _hoisted_16,
                        _createTextVNode(": " + _toDisplayString(reason), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasHelpCenterRequestIssue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("ul", _hoisted_19, [
                    _createElementVNode("li", null, [
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToAccountSection && _ctx.navigateToAccountSection(...args)), ["prevent"]))
                      }, "review >>")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["collapsed"]))
      : _createCommentVNode("", true),
    (_ctx.hasPolicies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_CollapsibleSection, {
            collapsed: _ctx.isBopPoliciesCollapsed,
            onToggleCollapse: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleBopPoliciesCollapsed()))
          }, {
            caption: _withCtx(() => [
              _hoisted_24
            ]),
            content: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bopPolicies, (policy) => {
                return (_openBlock(), _createBlock(_component_PolicyDetails, {
                  key: policy.policyNumber,
                  policyNumber: policy.policyNumber,
                  jobNumber: policy.jobNumber,
                  accountNumber: _ctx.accountInfo.AccountNumber,
                  product: policy.product,
                  status: policy.status,
                  period: policy.period,
                  term: policy.term,
                  transactionData: _ctx.transactionData
                }, null, 8, ["policyNumber", "jobNumber", "accountNumber", "product", "status", "period", "term", "transactionData"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["collapsed"]),
          _createVNode(_component_CollapsibleSection, {
            collapsed: _ctx.isWcPoliciesCollapsed,
            onToggleCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleWcPoliciesCollapsed()))
          }, {
            caption: _withCtx(() => [
              _hoisted_25
            ]),
            content: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attuneWcPolicies, (policy) => {
                return (_openBlock(), _createBlock(_component_PolicyDetails, {
                  key: `${policy.policyNumber}-${policy.term}`,
                  policyNumber: policy.policyNumber,
                  jobNumber: policy.jobNumber,
                  accountNumber: _ctx.accountInfo.AccountNumber,
                  product: policy.product,
                  status: policy.status,
                  period: policy.period,
                  term: policy.term,
                  transactionData: _ctx.transactionData
                }, null, 8, ["policyNumber", "jobNumber", "accountNumber", "product", "status", "period", "term", "transactionData"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["collapsed"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasQuotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_CollapsibleSection, {
            collapsed: _ctx.isBopQuotesCollapsed,
            onToggleCollapse: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleBopQuotesCollapsed()))
          }, {
            caption: _withCtx(() => [
              _hoisted_28
            ]),
            content: _withCtx(() => [
              (_ctx.hasRolloverQuotes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rolloverQuotes, (quote) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote.quoteNumber,
                        class: "rollover-section"
                      }, [
                        _createVNode(_component_QuoteDetails, {
                          quote: quote,
                          accountInfo: _ctx.accountInfo,
                          rolloverQuotes: _ctx.rolloverQuotes,
                          isRollover: true
                        }, null, 8, ["quote", "accountInfo", "rolloverQuotes"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!!_ctx.renewalQuotes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renewalQuotes, (quote) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote.quoteNumber,
                        class: "quote-section"
                      }, [
                        _createVNode(_component_QuoteDetails, {
                          quote: quote,
                          accountInfo: _ctx.accountInfo,
                          rolloverQuotes: _ctx.rolloverQuotes,
                          isRollover: false
                        }, null, 8, ["quote", "accountInfo", "rolloverQuotes"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!!_ctx.bopQuotes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bopQuotes, (quote) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote.quoteNumber,
                        class: "quote-section"
                      }, [
                        _createVNode(_component_QuoteDetails, {
                          quote: quote,
                          accountInfo: _ctx.accountInfo,
                          rolloverQuotes: _ctx.rolloverQuotes,
                          isRollover: false
                        }, null, 8, ["quote", "accountInfo", "rolloverQuotes"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["collapsed"]),
          _createVNode(_component_CollapsibleSection, {
            collapsed: _ctx.isWcQuotesCollapsed,
            onToggleCollapse: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleWcQuotesCollapsed()))
          }, {
            caption: _withCtx(() => [
              _hoisted_35
            ]),
            content: _withCtx(() => [
              (!!_ctx.attuneWcQuotes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attuneWcQuotes, (quote) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote.quoteNumber,
                        class: "quote-section"
                      }, [
                        _createVNode(_component_QuoteDetails, {
                          quote: quote,
                          accountInfo: _ctx.accountInfo,
                          rolloverQuotes: [],
                          isRollover: false
                        }, null, 8, ["quote", "accountInfo"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["collapsed"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isBlank)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, " This account has no quotes or policies associated with it. "))
      : _createCommentVNode("", true),
    (_ctx.accountInfo.hasGlQuote === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " This account has GL quotes or polices. "))
      : _createCommentVNode("", true),
    (_ctx.accountInfo.hasPlQuote === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, " This account has PL quotes or polices. "))
      : _createCommentVNode("", true),
    (_ctx.accountInfo.hasWcQuote === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " This account has WC quotes or polices. "))
      : _createCommentVNode("", true)
  ]))
}